@if(button.type === 'normal'){
  <button class="bttn" [ngClass]="[button.extraClass || '', disabled ? 'btn-grey-bdr' : '']" (click)="onClick()">
    <label>{{button.label}}</label>
    <span *ngIf="button.description">{{button.description}}</span>
  </button>
}@else if(button.type === 'prefix-icon'){
  <button class="bttn" [ngClass]="[button.extraClass || '', disabled ? 'btn-grey-bdr' : '']" (click)="onClick()">
    <img [src]="imageBase + button.icon" width="16" height="16" alt="{{button.label}}" title="{{button.label}}" /> 
    {{button.label}}
  </button>
}@else if(button.type === 'suffix-icon'){
  <button class="bttn" [ngClass]="[button.extraClass || '', disabled ? 'btn-grey-bdr' : '']" (click)="onClick()">
    {{button.label}}
    <img [src]="imageBase + button.icon" width="16" height="16" alt="{{button.label}}" title="{{button.label}}" /> 
  </button>
}